module.exports = __webpack_public_path__ + "img/traveller-idle.b3cc79f5.svg";